/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const helpTokens = {
  GraphicColorBaseDefault: '#2c67b5',
  FontColorBaseDefault: '#656b6b',
  FontWeightBaseDefault: '400',
  FontSizeBaseDefault: '12px',
  FontLeadingBaseDefault: '20px',
  SpacingBaseDefault: '6px',
  SpacingFieldDefault: '10px',
} as const;
